var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col text-center"},[_c('span',{staticClass:"link",on:{"click":_vm.showOrigin}},[_vm._v("Источники информации")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }